import * as React from 'react';
import ProjectDocument from 'src/entities/ProjectDocument';

interface Props {
  projectDocument: ProjectDocument;
  image: File;
  download(): void;
}

const ProjectDocumentMiniatureComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div>
    <p className="text-center">
      <img
        style={{ height: '169px' }}
        src={
          props.image ?
            // tslint:disable-next-line:no-any
            (window.URL || (window as any).webkitURL).createObjectURL(props.image) :
            '/img/docs.svg'
        }
        alt={props.projectDocument.name}
      />
    </p>
    <div
      className="grey-area text-center pointer"
      style={{
        height: '50px',
        padding: '0'
      }}
      onClick={props.download}
    >
      <img
        width=""
        alt="graphic"
        src="/img/graphic-doc.png"
      />
      <p>
        Descargar {props.projectDocument.name}
      </p>
    </div>
  </div>
);

export default ProjectDocumentMiniatureComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-documents/ProjectDocumentMiniature.component.tsx